
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata, IDocument } from "@tylertech/tyler-api-types";

/**
 * VendorDirectDepositService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class VendorDirectDepositService<TVendorRemitDD = unknown> {
    private readonly $apiService = inject(ApiService);
    
    DeleteVendorDirectDeposit(pId: string): Promise<void> {
        return this.$apiService.sendAuth("IVendorDirectDepositService/DeleteVendorDirectDeposit", pId);
    }
    GeneratePreNoteFile(records: string[]): Promise<IDocument[]> {
        return this.$apiService.sendAuth("IVendorDirectDepositService/GeneratePreNoteFile", records);
    }
    GetVendorDirectDepositForEdit(pId: string): Promise<TVendorRemitDD> {
        return this.$apiService.sendAuth("IVendorDirectDepositService/GetVendorDirectDepositForEdit", pId);
    }
    GetVendorDirectDepositMetaData(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IVendorDirectDepositService/GetVendorDirectDepositMetaData");
    }
    SaveVendorDirectDeposit(entity: TVendorRemitDD): Promise<TVendorRemitDD> {
        return this.$apiService.sendAuth("IVendorDirectDepositService/SaveVendorDirectDeposit", entity);
    }
}
